require('./Content.less');
